<template>
  <Master />
  <header class="header">
    <div class="container-fluid px-4">
      <div class="row">
        <div class="col-sm-2 col-12 logo-col">
          <div class="logo">
            <router-link :to="{ name: 'home' }">
              <img class="img-fluid" src="../../assets/images/logo/logo.png" alt="Nexus Marketplace">
            </router-link>
          </div>
        </div>

        <div class="col-sm-5 col-12">
          <Search />
        </div>
        <div class="col-sm-5 col-12">
          <button class="sidebar-toggle" @click="$emit('toggle-sidebar')">
            <i class="fas fa-bars" />
          </button>
          <div class="user-info">
            <div v-if="!$store.getters.isAuthenticated" id="logged-out-state">
              <div class="d-flex align-items-center">
                <div class="enki-body-sm-medium">
                  <router-link :to="{ name: 'Login' }">
                    Login
                  </router-link>
                </div>
                <div class="text-sm p-2">
                  |
                </div>
                <div class="enki-body-sm-medium">
                  <router-link :to="{ name: 'SignUp' }">
                    Sign
                    up
                  </router-link>
                </div>
              </div>
            </div>

            <div v-if="$store.getters.isAuthenticated" id="logged-in-state" class="dropdown">
              <div class="d-flex align-items-center">
                <img src="../../assets/images/avatar.jpg" style="border-radius: 50%; width: 32px; height: 32px;">
                <span style="margin: 0 8px; font-weight: 500;">
                  <a href="#" class="text-dark text-decoration-none"> My Account</a>
                </span>
                <i class="fas fa-chevron-down" style="font-size: 12px;" />
              </div>
              <div class="dropdown-content">
                <router-link to="/profile">
                  Profile
                </router-link>
                <a href="#">Orders</a>
                <a href="#">Settings</a>
                <a href="#">Logout</a>
              </div>
            </div>

            <router-link id="cartBtn" to="/cart" class="cart-btn">
              <i class="fas fa-shopping-cart" />
              <span v-if="$store.getters.updateMiniCart.length > 0" id="cartCount">{{
                $store.getters.updateMiniCart.length }}
                Cart</span>
            </router-link>

            <!-- Mobile Toggle Button (right side) -->
            <button class="mobile-toggle" @click="isMenuOpen = true">
              <i class="fas fa-bars" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
  <nav class="sub-nav">
    <div class="container-fluid px-4">
      <div class="topbar d-flex justify-content-between align-items-center">
        <!-- Navigation Menu -->
        <div v-show="isMenuOpen" class="overlay" @click="isMenuOpen = false" />
        <ul class="nav-links" :class="{ 'show': isMenuOpen }">
          <!-- Close button inside menu -->
          <li class="close-btn" @click="isMenuOpen = false">
            <i class="fas fa-times" />
          </li>
          <li>
            <router-link :to="{ name: 'Trending' }">
              <i class="fas fa-fire" /> New arrivals
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'BestSelling' }">
              <i class="fas fa-fire" /> Best Sellers
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'FlashSaleGallery' }">
              <i class="fas fa-fire" /> Deals
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'marketplace' }">
              Sell with Us
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'MerchantSignUp' }">
              Register as a Seller
            </router-link>
          </li>
          <li>
            <a href="#" style="color: #8b5cf6;">Refer Friends, Get $20</a>
          </li>

          <li>
            <router-link :to="{ name: 'OrderByPhone' }" class="menu-link text-danger">
              <i class="fas fa-phone" /> Order by Phone
            </router-link>
          </li>
          <li>
            <a href="https://ethnicdish.com/" target="_blank" class="mr-4">Blog</a>
          </li>
          <li>
            <a href="javascript:void(0)" data-toggle="modal" data-target="#addressModal">
              <i class="fas fa-map-marker-alt" />&nbsp;Deliver to
              <span class="ms-2 text-success mr-4" style="cursor: pointer;">&nbsp;&nbsp;{{ address }}
              </span>
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" data-toggle="modal" data-target="#dateModal">
              <i class="fas fa-calendar-alt" />&nbsp;Next Delivery Date
              <span class="ms-1 text-success" style="cursor: pointer;">&nbsp;&nbsp;{{ formattedDate
                }}</span>
            </a>
          </li>
        </ul>



        <div id="addressModal" class="modal fade" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content shadow-lg border-0 rounded-3">
              <!-- Header -->
              <div class="modal-header bg-light border-0 rounded-top">
                <h5 class="modal-title fw-semibold">
                  <i class="fas fa-map-marker-alt text-primary me-2" />
                  Deliver to
                </h5>
                <button type="button" class="btn-close" data-dismiss="modal" />
              </div>

              <!-- Body -->
              <div class="modal-body">
                <label class="form-label fw-medium">Enter Address</label>
                <div class="input-group mb-3">
                  <span class="input-group-text">
                    <i class="fas fa-home" />
                  </span>
                  <input v-model="newAddress" type="text" class="form-control" placeholder="Enter new address">
                </div>

                <button class="btn btn-outline-primary w-100" @click="detectLocation">
                  <i class="fas fa-crosshairs me-2" /> Detect My Location
                </button>
              </div>

              <!-- Footer -->
              <div class="modal-footer border-0">
                <button class="btn btn-light px-4" data-dismiss="modal">
                  Cancel
                </button>
                <button class="btn btn-primary px-4" data-dismiss="modal" @click="updateAddress">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div id="dateModal" class="modal fade" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content shadow-lg border-0 rounded-3">
              <div class="modal-header bg-light border-0 rounded-top">
                <h5 class="modal-title fw-semibold">
                  <i class="fas fa-calendar-alt text-success me-2" />
                  Next Delivery Date
                </h5>
                <button type="button" class="btn-close" data-dismiss="modal" />
              </div>

              <div class="modal-body">
                <label class="form-label fw-medium">Select Delivery Date</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fas fa-calendar-day" />
                  </span>
                  <input v-model="newDate" type="date" class="form-control">
                </div>
              </div>

              <div class="modal-footer border-0">
                <button class="btn btn-light px-4" data-dismiss="modal">
                  Cancel
                </button>
                <button class="btn btn-success px-4" data-dismiss="modal" @click="updateDate">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <Minicart :cart-items="cartItems" :subtotal="subtotal" />
</template>

<script>
import axios from '@/utils/axiosConfig';
import Master from '@/components/include/Master.vue'
import Nav from '@/components/include/Nav.vue'
import Minicart from '@/components/include/Minicart.vue'
import Search from '@/components/include/Search.vue'

export default {
  name: 'Header',
  components: {
    Master,
    // Nav,
    Minicart,
    Search
    // DeliveryDateModal
  },
  data() {
    return {
      error: '',
      subtotal: 0,
      cartItems: [],
      // Date and location
      address: "Detecting location...",
      newAddress: "",
      selectedDate: new Date(),
      newDate: null,
      isMenuOpen: false,
    }
  },
  computed: {
    formattedDate() {
      return this.selectedDate.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      });
    },
  },
  mounted() {
    this.detectLocation();
    this.getProduct();
    // this.storageTest()
  },
  methods: {
    updateAddress() {
      if (this.newAddress.trim()) {
        this.address = this.newAddress;
        this.newAddress = "";
      }
    },
    updateDate() {
      if (this.newDate) {
        this.selectedDate = new Date(this.newDate);
        this.newDate = null;
      }
    },
    detectLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const lat = pos.coords.latitude;
            const lon = pos.coords.longitude;

            fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
            )
              .then((res) => res.json())
              .then((data) => {
                const city =
                  data.address.city ||
                  data.address.town ||
                  data.address.village;
                const zip = data.address.postcode;
                this.address =
                  zip && city ? `${zip} ${city}` : city || "Location not found";
              })
              .catch(() => {
                this.address = "Unable to fetch address";
              });
          },
          () => {
            this.address = "Location access denied";
          }
        );
      } else {
        this.address = "Geolocation not supported";
      }
    },
    async handleLogout() {
      await this.$store.dispatch('LogOut')
      this.$router.push('/login')
    },
    getProduct() {
      axios.get(`mini-carts`).then((response) => {
        this.cartItems = response.data;
        localStorage.setItem('cartItemTotal', this.cartItems.length)
        this.cartItems.forEach(p => {
          this.subtotal += p.product.product_inventory.price * p.quantity;
          localStorage.setItem('itemTotal', this.subtotal)
        });
      });
    }
  }
}
</script>


<style>
.location-info {
  font-size: 16px;
  font-weight: 500;
}
</style>
